export function printInvoiceA4(invoiceData, formatNumber, t) {
    const safeText = (value, fallback = "-") => {
        if (value === undefined || value === null) return fallback;
        const text = String(value).trim();
        return text === "" ? fallback : text;
    };

    // Create a safe translation function with error handling
    const safeT = (key) => {
        try {
            return t(key);
        } catch (error) {
            console.warn(`Translation error for key "${key}":`, error);
            return key; // Return the key itself as fallback
        }
    };

    // Create a hidden iframe for printing
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    // Helper function to dynamically generate table rows
    const generateTableRows = (items, columns) => {
        return items
            .map((item, index) => {
                // Dynamically create a <td> for each column name provided
                const rowCells = columns
                    .map((column) => {
                        // Handle the special case for the '#' column
                        if (column === "#") {
                            return `<td>${index + 1}</td>`;
                        }
                        // Access the value using the column name as the key
                        return `<td>${item[column]}</td>`;
                    })
                    .join("");

                // const hasDiscount = invoiceData.summary.discount > 0;

                // Construct the full row
                return `
        <tr>
          ${rowCells}
        </tr>
      `;
            })
            .join("");
    };

    // Helper function to dynamically generate table headers
    const generateTableHeaders = (columns) => {
        // Map column names to translation keys
        const columnTranslations = {
            "#": "#",
            "item_name": "item_name",
            "cost": "cost",
            "quantity": "quantity",
            "bonus": "bonus",
            "discount": "discount",
            "total_price": "total_price"
        };

        return columns
            .map(
                (column) => {
                    const translationKey = columnTranslations[column] || column;
                    return `<th>${safeT(translationKey)}</th>`;
                }
            )
            .join("");
    };

    const hasDiscount = invoiceData.summary.discount > 0;
    const hasDebt = invoiceData.summary.debt > 0;

    const invoiceContent = `
    <html>
    <head>
      <title>${invoiceData.invoiceTitle || 'Invoice'}</title>
      <style>
        @font-face {
          font-family: 'kurd';
          src: url('https://storage.wisesale.app/Rabar_022-Busi21Jx.ttf') format('truetype');
        }

        body {
          font-family: 'kurd', sans-serif;
          direction: rtl;
          text-align: right;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background: white;
          margin: 0;
        }

        @page {
          size: A4;
          margin: 15mm;
        }
        
        .my_font { font-family: 'kurd' !important; }

        .invoice-container {
          max-width: 210mm;
          margin: 0 auto;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          padding: 10mm;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          
        }
          .headerBorder{
          border-bottom: 2px solid #eee;}
        .header h1 {
          font-size: 28px;
          color: #7165E3;
          margin: 0;
        }
        .header p {
          margin: 0;
          font-size: 12px;
          color: #777;
        }
        .header .company-info {
          text-align: right;
        }

        .summary-box {
          margin-top: 20px;
          background: #f2f2f2;
          padding: 10px;
          border-radius: 5px;
          line-height: 1.5;
        }
        .summary-box h3 {
          margin: 6px 0;
          font-size: 16px;
          font-weight: bold;
          color: #7165E3;
        }
        .summary-box h4 {
          margin: 4px 0;
          font-size: 14px;
        }
        .summary-box .debt {
          color: red;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #eee;
          padding: 10px;
          text-align: center;
        }
        th {
          background-color: #7165E3;
          color: white;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        .footer {
          margin-top: 40px;
          text-align: center;
          font-size: 14px;
        }
      </style>
    </head>
    <body>
      <div class="invoice-container">
        <!-- HEADER -->
        <div class="header headerBorder">
          <div class="company-info">
            <h1>${invoiceData.companyInfo.appName}</h1>
         
            <p>${safeT("phone number")}: ${
    invoiceData.companyInfo.phoneNumber +
    (invoiceData.companyInfo.phoneNumber2 != "" &&
    invoiceData.companyInfo.phoneNumber2 != null
      ? " - " + invoiceData.companyInfo.phoneNumber2
      : "")
  }</p>
              <p>${safeT("address")}: ${invoiceData.companyInfo.address}</p>
          </div>
        <!--   <div class="company-logo">
            <img src="${
              invoiceData.companyInfo.logoUrl
            }" alt="Company Logo" style="max-width: 100px; max-height: 100px;">
          </div> -->
          <div>
            <h1 style="color: #333; font-size: 20px;">${safeT(
              invoiceData.headerMessage
            )}</h1>
            <p><strong>${safeT("invoice_id")}:</strong> ${
    invoiceData.invoiceId || "-"
  }</p>
            <p><strong>${safeT("date")}:</strong> ${invoiceData.invoiceDate}</p>  
          </div>
        </div>
         <div class="header">
<h2 style="color: #333; font-size: 18px;">${
    (invoiceData.name_var ? safeT(invoiceData.name_var) : "Name") +
    " : " +
    safeText(invoiceData.id) +
    " - " +
    safeText(invoiceData.name)
  }</h2>
  <h2 style="color: #333; font-size: 16px;">${
    invoiceData.number_wasl == null || invoiceData.number_wasl == ""
      ? ""
      : (invoiceData.number_wasl_var ? safeT(invoiceData.number_wasl_var) : "Number") + " : " + invoiceData.number_wasl
  }</h2>
  </div>
        <!-- LINE ITEMS TABLE -->
        <table>
          <thead>
            <tr>
              ${generateTableHeaders(invoiceData.tableColumns)}
            </tr>
          </thead>
          <tbody>
            ${generateTableRows(invoiceData.items, invoiceData.tableColumns)}
          </tbody>
        </table>

     ${
  invoiceData.note
    ? `
    <div class="summary-box" style="margin: 10px 0 !important; padding: 8px !important;">
      <h3 style="margin: 0 0 5px 0 !important;">${safeT("note")}</h3>
      <p style="margin: 0 !important;">${invoiceData.note}</p>
    </div>
    `
    : ``
}
      
    <!-- SUMMARY SECTION -->
        <div class='header'>
          ${
            invoiceData.beforeDebtIQD > 0 ||invoiceData.beforeDebtIQD<0 ||
            invoiceData.beforeDebtUSD > 0 ||
            invoiceData.beforeDebtUSD < 0 ||
            invoiceData.balanceUpToAndIncludingDateIQD > 0 ||
            invoiceData.balanceUpToAndIncludingDateUSD < 0 ||
            invoiceData.balanceUpToAndIncludingDateIQD < 0 ||
            invoiceData.balanceUpToAndIncludingDateUSD > 0
              ? `
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">

        
  <div style="background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box; min-width: 200px;">
    
    <!-- Balance Before -->
    <div style="padding: 4px 0; ">
      <div style="font-size: 14px; ">
        ${safeT(
          "balance_before"
        )}: <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(invoiceData.beforeDebtIQD)} ${safeT("dinar")}
      </div>
      </div>
      
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(invoiceData.beforeDebtUSD)} ${safeT("dollar")}
      </div>
    </div>

    <!-- Balance After -->
    <div style="padding: 4px 0;  margin-top: 10px;">
      <div style="font-size: 14px; ">
        ${safeT("balance_after")}:
      </div>
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(invoiceData.balanceUpToAndIncludingDateIQD)} ${safeT(
    "dinar"
  )}
      </div>
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(invoiceData.balanceUpToAndIncludingDateUSD)} ${safeT(
    "dollar"
  )}
      </div>
    </div>

  </div>
</div>
              `
              : ``
          }
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <div style="; background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box;">
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 17px; font-weight: normal; color: #555;">${safeT(
                "items_price"
              )}:</span>
              <span style="font-size: 17px; font-weight: normal; color: #333;">  ${
                formatNumber(invoiceData.summary.itemsPrice) +
                invoiceData.currency
              }</span>
            </div>
            ${
              hasDiscount
                ? `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 17px; font-weight: normal; color: #555;">${safeT(
                "discount"
              )}:</span>
              <span style="font-size: 17px; font-weight: normal; color: #333;">${
                formatNumber(invoiceData.summary.discount) +
                invoiceData.currency
              }</span>
            </div>
            `
                : ``
            }
            <div style="display: flex; justify-content: space-between; padding: 4px 0; font-size: 18px; color: #333;">
              <span style=" color: #555;">${safeT("final_price")}:</span>
              <span style=" font-weight: bold;">${
                formatNumber(invoiceData.summary.finalPrice) +
                invoiceData.currency
              }</span>
            </div>
            ${
              hasDebt
                ? `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 18px; font-weight: normal; color: #555;">${safeT(
                "paid_money"
              )}:</span>
              <span style="font-size: 18px; font-weight: bold; color: #008000;">${
                formatNumber(invoiceData.summary.paidAmount) +
                invoiceData.currency
              }</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 4px 0">
              <span style="font-size: 18px; ; color: #555;">${safeT("debt")}:</span>
              <span style="font-size: 18px; font-weight: bold;; color: red;">${
                formatNumber(invoiceData.summary.debt) + invoiceData.currency
              }</span>
            </div>
            `
                : ``
            }
          </div>
        </div>
        </div>

        <!-- FOOTER -->
       
      </div>
    </body>
    </html>
  `;

  // Write the generated HTML to the iframe
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(invoiceContent);
  doc.close();

  // Wait a moment before printing
  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
       // Cleanup
    }, 50); // slight delay ensures content is loaded
  };
}

// You would call the function like this:
// printInvoiceA4(sampleData, formatNumber, t);
//
// You will need to define your own formatNumber and t functions in your code.
// E.g.,
// function formatNumber(num) {
//   return new Intl.NumberFormat().format(num);
// }
// function t(key) {
//   // Your translation logic here
//   const translations = {
//     invoice_title: 'Invoice',
//     invoice_title_name: 'Sales Invoice',
//     // ... other translations
//   };
//   return translations[key] || key;
// }